import {
   rand,
   randNumber,
   randWord,
   randCompanyName,
   randAccount,
   randStreetAddress,
   randCity,
   randZipCode,
   randEmail,
   randFullName,
   randFirstName,
   randLastName,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';
import { MockCountries } from '@library/common/models/mock';

import { MockAdminSourceSystem } from '../admin-source-system.mock';
import {
   AccountListItem,
   Account, AccountActions,
   AccountUser,
   AccountBookingConfirmation,
} from './admin-account';

export class MockAccountListItem extends AccountListItem {
   constructor() {
      super({
         id: randNumber(),
         name: randCompanyName(),
         accountNumber: randAccount(),

         groups: randWord({ length: randNumber({
            min: 1,
            max: 3,
         }) }),

         users: Array.from({ length: randNumber({
            min: 1,
            max: 10,
         })}, _ => ({
            email: randEmail(),
            name: randFullName(),
         })),

         services: Array.from({ length: randNumber({
            min: 1,
            max: 5,
         })}, _ => new MockAdminSourceSystem() ),
      });
   }
}

export class MockAdminAccount extends Account {
   constructor() {
      super({
         id: randNumber(),
         name: randCompanyName(),
         accountNumber: randAccount(),

         address1: randStreetAddress(),
         address2: optional() ? null : randStreetAddress(),
         city: randCity(),
         postalcode: randZipCode(),

         actions: AccountActions,
      });

      const country = rand( MockCountries() );

      this.country = country?.code;
      this.state = rand( country?.regions ?? [] )?.code;
   }
}

export class MockAccountUser extends AccountUser {
   constructor() {
      super({
         email: randEmail(),
         firstName: randFirstName(),
         lastName: randLastName(),
      });
   }
}

export class MockAccountBookingConfirmation extends AccountBookingConfirmation {
   constructor() {
      super({
         replyTo: optional( 30 ) ? randEmail() : '',
         parties: Array.from({ length: randNumber({
            min: 1, max: 5,
         })}, _ => ({
            email: optional() ? randEmail() : 'user',
            recipientType: rand([ 'to', 'cc', 'bcc' ]),
            brand: rand([ 'AIRGROUP', 'RADIANT', 'ADCOM', 'DBA' ]),
         })),
      });
   }
}
